<mat-form-field style="width:7vw" appearance="outline">
  <input size="10" matInput [matDatepicker]="picker" placeholder="{{ placeholder }}" [formControl]="dateControl"
    (dateChange)="picker.close()" />
  <mat-datepicker-toggle matSuffix [for]="picker">
    <div class="icon-override size-22 calendar-icon" matDatepickerToggleIcon></div>
  </mat-datepicker-toggle>
  <mat-datepicker #picker startView="year"></mat-datepicker>
</mat-form-field>